import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QueryParamsArService {

  constructor(private router: Router) { }

  getParams(route: ActivatedRoute): Observable<any> {
    return route.queryParams;
  }

  getParam(route: ActivatedRoute, key: string): string | null {
    return route.snapshot.queryParamMap.get(key);
  }

  getNumberParam(route: ActivatedRoute, key: string, defaultValue: number): number {
    const value = Number(route.snapshot.queryParamMap.get(key));
    return isNaN(value) ? defaultValue : value;
  }

  getStringParam(route: ActivatedRoute, key: string, defaultValue: string): string {
    const value = route.snapshot.queryParamMap.get(key);
    return value && value.trim() !== '' ? value : defaultValue;
  }

  setParams(route: ActivatedRoute, params: any): void {
    this.router.navigate([], {
      relativeTo: route,
      queryParams: params,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  removeParam(route: ActivatedRoute, key: string): void {
    const currentParams = { ...route.snapshot.queryParams };
    delete currentParams[key];

    this.router.navigate([], {
      relativeTo: route,
      queryParams: currentParams,
      replaceUrl: true
    });
  }

  clearParams(route: ActivatedRoute): void {
    this.router.navigate([], {
      relativeTo: route,
      queryParams: {},
      replaceUrl: true
    });
  }
}
